import { Route, Routes } from "react-router-dom";
import EditAccount from "./EditAccount/EditAccount";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { useAuthorization } from "@common/providers";

interface AccountMspaProps {
  sidebarWidth?: number;
}

const AccountMspa = ({ sidebarWidth }: AccountMspaProps): JSX.Element => {
  const authorized = useAuthorization();

  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route
        path="/:user_id/edit/*"
        element={<EditAccount sidebarWidth={sidebarWidth} />}
      />
    </Routes>
  );
};

export default AccountMspa;
